import { isAdmin } from '~/enums/roles';

/**
 * Pure decision for the Notes card editor (ACT-18544 item 4). No UI imports:
 * this is the one place the rule lives, unit-tested standalone.
 *
 * The server rule (tpaccurate-api#189): the four note handlers carry a
 * stored-row portfolio role guard that answers 403 for role users on
 * portfolio rows, and the shared axios interceptor turns ANY 403 into a
 * forced logout - so the editor must not be offered to them in the first
 * place. Outside the portfolio the guard does not apply and every role keeps
 * editing. Fail closed: an unknown or undefined role fails isAdmin and gets
 * the read-only card on portfolio rows.
 *
 * `editable` (the server's Draft/trash 400 rule) is deliberately NOT an
 * input: uneditable rows are refused before the role check there.
 */
export function isNoteEditable(role, isPortfolio, status, isInTrash) {
  return (isAdmin(role) || !isPortfolio) && status === 'Draft' && !isInTrash;
}
